import {
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  toolbarPlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  InsertImage,
  InsertTable,
  ListsToggle,
  imagePlugin,
  tablePlugin, BlockTypeSelect,
  directivesPlugin,
} from '@mdxeditor/editor'

import '@mdxeditor/editor/style.css'
import { Cookies } from "react-cookie";
import { MyTextEditorProps } from "./props";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { MyTextEditor } from './styles'
import { COOKIE_KEY, FILE_FORM_API, LANG_KEY } from "../../../constants";
import { getFromUrl } from "../../../utils/getFromUrl";
import { axiosConfigNew } from "../../../utils/axios";
import { LatexButton, LatexDirectiveFn } from './module/LatexFormat';

const cookies = new Cookies()

const imageUploadHandler = async (image: File): Promise<string> => {
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)
  let lang = cookies.get(COOKIE_KEY.LANG) || (getFromUrl(COOKIE_KEY.LANG_OLD) ?? getFromUrl(COOKIE_KEY.LANG)) || LANG_KEY.RU
  let formData = new FormData();
  let url = FILE_FORM_API.FILE

  formData.append("yModel", 'Upload');
  formData.append("Upload[file]", image);
  formData.append("Upload[name]", image.name);

  const res = await axiosConfigNew.post(url, formData)

  return res.data.url
}

export const TextEditor = React.forwardRef<any, MyTextEditorProps>((props, ref) => {
  const { value, onChange, disabled = false, extra } = props
  const { t } = useTranslation("textEditor")

  return (
    <MyTextEditor
      markdown={value ? value : ''}
      ref={ref}
      plugins={[
        headingsPlugin(),
        imagePlugin({
          imageUploadHandler: imageUploadHandler,
        }),
        tablePlugin(),
        listsPlugin(),
        quotePlugin(),
        directivesPlugin({ directiveDescriptors: [LatexDirectiveFn(disabled)] }), // директива для показывания TeX
        toolbarPlugin({
          toolbarContents: () => (
            !disabled && (
              <>
                <UndoRedo />
                <BoldItalicUnderlineToggles />
                <BlockTypeSelect />
                <InsertImage />
                <InsertTable />
                <ListsToggle />
                {/*  кнопка для создания TeX */}
                <LatexButton />
                <div style={{ flex: 1, justifyContent: 'end', display: 'flex' }}>
                  {extra}
                </div>
              </>
            )
          ),
        })
      ]}
      onChange={(values) => onChange ? onChange(values) : {}}
      translation={(key, defaultValue, interpolations) => {
        return t(key, defaultValue, interpolations) as string
      }}
      readOnly={disabled}
    />
  )
})
